import { TaxGroup, TaxGroupInput } from '@/types/schemas/nhom-thue.type';
import { useTaxGroup as useTaxGroupQuery } from '@/hooks/queries';

export const useTaxGroup = () => {
  const {
    taxGroups: groups,
    isLoading,
    addTaxGroup: addTaxGroupQuery,
    updateTaxGroup: updateTaxGroupQuery,
    deleteTaxGroup: deleteTaxGroupQuery,
    refreshTaxGroups,
    fetchTaxGroupsByType
  } = useTaxGroupQuery();

  const taxGroups = groups;

  const addTaxGroup = async (formData: TaxGroupInput): Promise<TaxGroup> => {
    try {
      const apiData: TaxGroupInput = {
        ma_nhom: formData.ma_nhom,
        ten_phan_nhom: formData.ten_phan_nhom,
        ten2: formData.ten2,
        trang_thai: formData.trang_thai,
        loai_nhom: formData.loai_nhom || 'TAX'
      };
      return await addTaxGroupQuery(apiData);
    } catch (error) {
      console.error('Error adding tax group:', error);
      throw error;
    }
  };

  const updateTaxGroup = async (data: TaxGroupInput & { uuid: string }): Promise<TaxGroup> => {
    try {
      const { uuid, ...formData } = data;

      const apiData: TaxGroupInput = {
        ma_nhom: formData.ma_nhom,
        ten_phan_nhom: formData.ten_phan_nhom,
        ten2: formData.ten2,
        trang_thai: formData.trang_thai,
        loai_nhom: formData.loai_nhom || 'TAX'
      };

      return await updateTaxGroupQuery(uuid, apiData);
    } catch (error) {
      console.error('Error updating tax group:', error);
      throw error;
    }
  };

  const deleteTaxGroup = async (id: string): Promise<void> => {
    try {
      await deleteTaxGroupQuery(id);
    } catch (error) {
      console.error('Error deleting tax group:', error);
      throw error;
    }
  };

  return {
    taxGroups,
    isLoading,
    addTaxGroup,
    updateTaxGroup,
    deleteTaxGroup,
    refreshTaxGroups,
    fetchTaxGroupsByType
  };
};
